import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  onRefresh = new Subject();

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  fetchOrders() {
    return this.http.get(`${environment.apiUrl}/order/assigned-to-me`).pipe();
  }

  fetchOrdersThirdParty(data) {
    return this.http
      .post(`${environment.apiUrl}/order/assigned-to-me-third-party`, data)
      .pipe();
  }

  claimOrder(special_id) {
    return this.http
      .get(`${environment.apiUrl}/order/assign-to-me/${special_id}`)
      .pipe();
  }

  markAsDelivered(order_id) {
    return this.http
      .get(`${environment.apiUrl}/order/deliver/${order_id}`)
      .pipe();
  }

  thirdPartyClaimOrder(order_id) {
    return this.http
      .get(`${environment.apiUrl}/order/third-party-order-claim/${order_id}`)
      .pipe();
  }

  thirdPartyUnclaimOrder(order_id) {
    return this.http
      .get(`${environment.apiUrl}/order/third-party-order-unclaim/${order_id}`)
      .pipe();
  }

  thirdPartyRemoveClaimOrder(order_id) {
    return this.http
      .get(
        `${environment.apiUrl}/order/third-party-order-remove-claim/${order_id}`
      )
      .pipe();
  }
}
